/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userTracking_regionalInfo = {
    readonly incomeLevel: {
        readonly incomeBracket: string | null;
        readonly incomePercentile: string | null;
    } | null;
    readonly " $refType": "userTracking_regionalInfo";
};
export type userTracking_regionalInfo$data = userTracking_regionalInfo;
export type userTracking_regionalInfo$key = {
    readonly " $data"?: userTracking_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"userTracking_regionalInfo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_regionalInfo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode"
        }
      ],
      "concreteType": "IncomeLevel",
      "kind": "LinkedField",
      "name": "incomeLevel",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incomeBracket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incomePercentile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RegionalInfo",
  "abstractKey": null
};
(node as any).hash = 'f02bdb39ee092a2d4baa8aff15f762e3';
export default node;
